import { FC, useState } from 'react'
import CaseFilter from '../statistics';
import CaseVolume from '../caseVolumeLineChart';
import CustomPieChart from '../customPieChart';
import GeographicalStatistics from '../geographicalStatistics';
import { GeographicalStatisticsObject } from 'src/pages/manufacturer/types';
import { AllProductProps } from '../allProductsStats/types';
// import AuthMaunfacturerSubHeader from '../authManufacturerSubHeader';
import CustomComponentDoctor from '../customDoctor';
import DrillDownPieChart from '../drillDownPieChart';
import CaseListing from '../caseListing';
const AllProductsTerritories: FC<AllProductProps> = ({ statisticsData, queryParams, updateQueryParamsAndCallAPI, getStatisticsData, drug }): JSX.Element => {
    const [caseData, updateCaseData] = useState<{ total_case: string; drug_cases: string; }>({ total_case: "", drug_cases: "" })

  return (
    <div className={`${drug === "iovera" ? 'iovera-content' : drug === "ZILRETTA" ? 'zilretta-content' : ''}`} >
        {statisticsData && (
            <CaseFilter
                defaultQueryParams={queryParams}
                updateQueryParams={updateQueryParamsAndCallAPI}
                drug={drug}
            />
        )}
        {statisticsData && queryParams && (
            <CaseVolume drug={drug} startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} getStatisticsData={getStatisticsData}
                        buttonShows={true} showPractice={true} />
        )}
        <div className='row'>
            <div className='col-12 col-lg-6'>
                {statisticsData &&
                    <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'} />}
            </div>
            {/* <div className='col-12 col-lg-6'>
                {statisticsData && statisticsData.data &&
                    <CustomPieChart title="Top 10 Payors Requiring PA" pieChartObject={statisticsData.data.top_pa_payors} />}
            </div> */}
            <div className="col-12 col-lg-6">
              {statisticsData && statisticsData.data &&
                <CustomPieChart title="Top 10 Payor Types" pieChartObject={statisticsData.data.top_payer_types} />
              }
          </div>
            <div className='col-12 col-lg-12'>
                {statisticsData && statisticsData.data &&
                    <DrillDownPieChart pieChartObject={statisticsData.data.icd_data} title={'Top 10 ICD Codes'} />}
            </div>
            {statisticsData && drug && queryParams && (
                <CustomComponentDoctor drug={drug} caseData={caseData} startDate={queryParams.start_date} endDate={queryParams.end_date} StatisticsObjectType={statisticsData.data} title={'Doctors'} isFullRow />)}
        </div>

        {statisticsData && statisticsData.data ?
                <CaseListing drug={drug} queryParams={queryParams} caseListing={statisticsData.data.case_listing} updateCaseData={updateCaseData} />
                : null
            }

        {statisticsData?.data && (
            <GeographicalStatistics
                GeographicalStatisticsListType={
                    statisticsData?.data
                        .geographical_stats as unknown as GeographicalStatisticsObject[]
                }
            />
        )}
    </div>
  );
}
export default AllProductsTerritories;